module.exports = __webpack_public_path__ + "img/20190531160643265.0e9573ff.png";